import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const AppleDevice916: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <style>{'.apple9-16_svg__cls-1{fill:#fff}.apple9-16_svg__cls-3{fill:#9e9e9e}'}</style>
    </defs>
    <g id="apple9-16_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="apple9-16_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path
          className="apple9-16_svg__cls-1"
          d="M6.28 39.65h131.78v74.42H6.28zM138 39.65v-18a14.29 14.29 0 00-14.25-14.32h-14.1v1.92a7.58 7.58 0 01-7.57 7.59h-59a7.58 7.58 0 01-7.58-7.59V7.33H20.56A14.3 14.3 0 006.28 21.64v18z"
        />
        <path
          className="apple9-16_svg__cls-1"
          d="M6.28 112.23v167a14.31 14.31 0 0014.31 14.31h103.1a14.31 14.31 0 0014.31-14.3v-167z"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <path fill="none" stroke="#f5f5f5" strokeMiterlimit={10} d="M6.41 259.03h131.36" />
        <circle className="apple9-16_svg__cls-3" cx={20.18} cy={270.75} r={5.23} />
        <circle className="apple9-16_svg__cls-3" cx={45.34} cy={270.75} r={5.23} />
        <circle cx={70.51} cy={270.75} r={5.23} fill="#1784eb" />
        <circle className="apple9-16_svg__cls-3" cx={95.67} cy={270.75} r={5.23} />
        <circle className="apple9-16_svg__cls-3" cx={120.83} cy={270.75} r={5.23} />
        <rect
          x={-47.05}
          y={75.06}
          width={238.08}
          height={131.95}
          rx={9.26}
          transform="rotate(90 71.995 141.045)"
          fill="#c0ebf9"
        />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default AppleDevice916;
